import React, { useState, useEffect } from 'react'
import './styles.css'
import { NavBar } from '../../components/navBar/navbar'
import { Header } from '../../components/header/header'
import { Menu } from '../../components/menu/menu.jsx'
import LoadContainer from '../../components/loading'
import { postOrder } from '../../services/api'
import { getProjectsCookies } from '../../services/updateData'
import Cookies from 'js-cookie'
import { useContext } from 'react'
import { AuthContext } from '../../contexts/auth'

const Order = () => {
	const [projects, setProjects] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [name, setName] = useState()
	const [notes, setNotes] = useState()
	const [date, setDate] = useState()
	const [asana_id, setAsana_id] = useState()
	const [statusMsg, setStatusMsg] = useState('')

	let check = false

	const askForProjects = async () => {
		setIsLoading(true)
		const newProjects = await getProjectsCookies()
		setProjects(newProjects)
		setIsLoading(false)
	}
	const goHome = () => {
		window.location.href = '/home'
	}

	const handleFormSubmit = async (e) => {
		e.preventDefault()
		setIsLoading(true)
		const newTask = {
			name: name,
			notes: notes,
			due_on: date,
		}
		const response = await postOrder(asana_id, newTask)
		setName('')
		setNotes('')
		setDate('')
		if (response.status === 200) {
			console.log(response.status)
			alert('Sua demanda foi enviada para análise. Nossa equipe será acionada!')
		} else {
			alert('Erro ao solicitar demanda.')
		}
		setIsLoading(false)
	}

	useEffect(() => {
		if (!check) {
			check = true
			askForProjects()
		}
	}, [])

	return (
		<div id="orderPage">
			<NavBar></NavBar>
			<div className="column">
				<Menu></Menu>
				<Header></Header>
				<div className="main-order">
					{isLoading ? <LoadContainer></LoadContainer> : ''}
					<span className="material-symbols-outlined goback" onClick={goHome}>
						arrow_back
					</span>
					<form id="order-form" className="order-form" onSubmit={handleFormSubmit}>
						<h1 className="order-title">Nova Demanda</h1>
						<div className="field">
							<label htmlFor="projeto">Escolha um Caso:</label>
							<select
								name="projetos"
								onChange={(e) => {
									setAsana_id(e.target.value)
								}}
								id="projetos"
								required
							>
								<option value={null} selected disabled></option>
								{projects
									? projects.map((project, index) => (
											<option key={index} value={project.id}>
												{project.name}
											</option>
									  ))
									: ''}
							</select>
						</div>
						<div className="field">
							<label htmlFor="atividade">Nome da demanda:</label>
							<input
								id="atividade"
								onChange={(e) => {
									setName(e.target.value)
								}}
								value={name}
								type="text"
								required
							></input>
						</div>
						<div className="field">
							<label htmlFor="descricao">Descrição da demanda:</label>
							<textarea
								id="descricao"
								onChange={(e) => {
									setNotes(e.target.value)
								}}
								value={notes}
								required
							></textarea>
						</div>
						<div className="field">
							<label htmlFor="prazo">Sugestão de prazo:</label>
							<input
								id="prazo"
								onChange={(e) => {
									setDate(e.target.value)
								}}
								value={date}
								type="date"
								required
							></input>
						</div>
						<div className="submit-btn-box">
							<input type="submit" className="submit-btn" value="Enviar" />
						</div>
						<span className="submit-msg">{statusMsg}</span>
					</form>
				</div>
			</div>
		</div>
	)
}
export default Order
